var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plans-wrapper" },
    [
      _c(
        "div",
        {
          staticClass:
            "intro-wrapper m-auto text-center d-flex flex-column align-items-center",
        },
        [
          _c("div", { staticClass: "heading-text-wrapper" }, [
            _c("h1", { staticClass: "header font-outfit-bold text-center" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isAppSumoUser
                      ? _vm.$t(
                          "pages.pricing.lifetimePlansSection.appSumoTitle"
                        )
                      : _vm.$t("pages.pricing.lifetimePlansSection.title")
                  ) +
                  " "
              ),
            ]),
            _c("div", { staticClass: "subheader" }, [
              _c("p", { staticClass: "font-outfit-light m-0" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isAppSumoUser
                        ? _vm.$t(
                            "pages.pricing.lifetimePlansSection.appSumoDescription"
                          )
                        : _vm.$t(
                            "pages.pricing.lifetimePlansSection.description"
                          )
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "rating-section-wrapper" },
            [_c("rating-section")],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "cards-wrapper text-center mt-lg-0" },
        [
          _c(
            "el-row",
            {
              staticClass:
                "cards-container d-flex flex-wrap m-auto text-center justify-content-center",
              attrs: { gutter: 14 },
            },
            _vm._l(_vm.plans, function (plan) {
              return _c(
                "el-col",
                {
                  key: plan.title,
                  staticClass: "mb-lg-0",
                  class: { "mt-md-3 mt-lg-0": !plan.popular },
                  attrs: { md: 9 },
                },
                [
                  _c("plan-card", {
                    staticClass: "plan-card mb-md-0",
                    attrs: {
                      dark: "",
                      title: plan.title,
                      plan: _vm.getPlan(plan.slug),
                      popular: plan.popular,
                      description: plan.description,
                      price: _vm.getPlan(plan.slug)
                        ? _vm.getPlan(plan.slug).price
                        : null,
                      "currency-symbol": _vm.getPlan(plan.slug)
                        ? _vm.getPlan(plan.slug).currency
                        : null,
                      period: _vm.period,
                      options: _vm.plansOptions,
                      loading: _vm.loading,
                      "button-loading": plan.slug === _vm.loadingPlanSlug,
                      "disabled-features": plan.disabledFeatures,
                    },
                    on: {
                      "choose-plan": (value) =>
                        _vm.onChoosePlan(plan.slug, value),
                      contact: _vm.onContact,
                    },
                    model: {
                      value: _vm.cardValues[_vm.period][plan.slug],
                      callback: function ($$v) {
                        _vm.$set(_vm.cardValues[_vm.period], plan.slug, $$v)
                      },
                      expression: "cardValues[period][plan.slug]",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c("p", { staticClass: "prices-info" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "pages.pricing.pricesMayBeSubjectToAdditionalVatDependingOnYourCountry"
                  )
                ) +
                " 👆 "
            ),
          ]),
        ],
        1
      ),
      _c("dialog-enterprise", {
        attrs: { "enterprise-visible": _vm.dialogEnterpriseVisible },
        on: {
          "close-enterprise": function ($event) {
            _vm.dialogEnterpriseVisible = false
          },
        },
      }),
      _c("dialog-confirm", {
        ref: "dialogConfirm",
        attrs: {
          visible: _vm.dialogConfirm,
          "preview-data": _vm.previewData,
          record: _vm.chosenData,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.dialogConfirm = false
          },
          "confirm-dialog": _vm.confirmedUpdatePlan,
        },
      }),
      _c("dialog-thank-you", {
        attrs: {
          "dialog-thank-you-visible": _vm.dialogThankYouVisible,
          "thank-you-data": _vm.chosenData,
        },
        on: { "close-dialog": _vm.closeDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }